import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-200">
        <img
          src={movie.image}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} 影视资源`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-primary-950/85 px-2 py-1 text-xs font-bold text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[10px] leading-none"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-primary-950">
          {movie.type}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base" title={movie.title}>
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{movie.genres[0]}</span>
          <span>{movie.region}</span>
          <span>{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}